'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var options = {};

var setAuthToken = exports.setAuthToken = function setAuthToken(token) {
  options.__AUTH_TOKEN__ = token;
};

var getAuthToken = exports.getAuthToken = function getAuthToken() {
  return options.__AUTH_TOKEN__;
};

var setHeaders = exports.setHeaders = function setHeaders(headers) {
  options.__API_HEADERS__ = (typeof headers === 'undefined' ? 'undefined' : _typeof(headers)) === 'object' ? headers : {};
};

var getHeaders = exports.getHeaders = function getHeaders() {
  return options.__API_HEADERS__;
};

var setApiUrl = exports.setApiUrl = function setApiUrl(url, version) {
  if (!version) {
    options.__API_URL__ = url;
  } else {
    options['__API_URL__v' + version] = url;
  }
};

var getApiUrl = exports.getApiUrl = function getApiUrl(version) {
  if (!version) {
    return options.__API_URL__;
  } else return options['__API_URL__v' + version];
};

var getOptions = exports.getOptions = function getOptions(f) {
  return options;
};


//////////////////
// WEBPACK FOOTER
// ./~/@hailtrace/client-api/dist/config.js
// module id = 235
// module chunks = 0